import React from "react";

const SpaceshipLanding = (props) => {
  return (
    <svg width={74} height={72} viewBox="0 0 74 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M43.507 19.652c3.17-1.083 6.487 1.196 6.613 4.543l.972 25.79c.154 4.109-4.44 6.638-7.828 4.31L17.869 36.847c-3.388-2.328-2.675-7.523 1.215-8.852l24.423-8.343z"
        fill="#0B132B"
      />
      <path
        d="M33.41 26.966L23.59 40.32l3.183-29.408 6.636 16.053zM46.876 36.198L37.9 50.132l26.343-13.46-17.366-.474z"
        fill="#5289E3"
      />
      <path
        d="M23.263 43.871L49.452 5.755a6.982 6.982 0 1111.51 7.908l-26.19 38.116-11.51-7.908z"
        fill="#4D6AFA"
      />
      <path
        d="M28.537 43.156a1.915 1.915 0 01.494 2.662l-3.086 4.49-3.156-2.167 3.086-4.492a1.915 1.915 0 012.662-.493zM33.735 46.727a1.915 1.915 0 01.494 2.662l-3.086 4.491-3.156-2.168 3.086-4.491a1.915 1.915 0 012.662-.494z"
        fill="#0B132B"
      />
    </svg>
  );
};

export default SpaceshipLanding;
